import type { RibbonId } from 'owa-ribbon-ids';
import { type MailRibbonGroup, defaultConfig } from 'owa-mail-ribbon-store-shared-types';

/**
 * Returns a set of valid config Ids from a specific tab layout. Useful to be called for different tabs.
 * @param layout `TabScalingAndLayoutConfig['layout']`, should be from defaultConfig
 */
function getValidDefaultConfigIds(layout: MailRibbonGroup[]): Set<RibbonId> {
    const validIds: Set<RibbonId> = new Set();

    for (const { controlIds, groupId } of layout) {
        validIds.add(groupId);

        for (const controlId of controlIds) {
            validIds.add(controlId);
        }
    }

    return validIds;
}

const { homeTab, viewTab } = defaultConfig.singleline;
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function getValidDefaultConfigIds called at module scope is not allowed. This may cause unwanted side effects. */
export const homeTabValidDefaultConfigIds: Set<RibbonId> = getValidDefaultConfigIds(homeTab.layout);
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function getValidDefaultConfigIds called at module scope is not allowed. This may cause unwanted side effects. */
export const viewTabValidDefaultConfigIds: Set<RibbonId> = getValidDefaultConfigIds(viewTab.layout);
